import { Button } from 'omakase';
import { FunctionComponent } from 'react';
import { PatronLocationComponentProps } from 'components/patron-location/PatronLocationButton';
import { css } from '@emotion/react';

// Maximum width to ensure that button text does not interfere with other mobile header items
const BUTTON_MAX_WIDTH = '225px';

export const PatronLocationGhostButton: FunctionComponent<PatronLocationComponentProps> = ({
  loading = false,
  locationText,
  onClick,
}) => {
  return (
    <Button
      aria-haspopup
      component="button"
      disabled={loading}
      onClick={onClick}
      size="medium"
      disclosure
      variant="ghost"
      data-testid="location-ghost-button"
      css={css`
        max-width: ${BUTTON_MAX_WIDTH};
      `}
    >
      {loading ? 'Loading' : locationText}
    </Button>
  );
};
